import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material";
import { ServerService } from "src/app/services/server.service";
import { ClipBoardService as messageService } from "src/app/services/clipboard.service";
@Component({
  selector: "app-create-presales-job",
  templateUrl: "./create-presales-job.component.html",
  styleUrls: ["./create-presales-job.component.scss"],
  encapsulation:ViewEncapsulation.None
})
export class CreatePresalesJobComponent implements OnInit {
  createPresalesJob: FormGroup;
  presales_calling_reason_list: any;
  presales_calling_type_list: any;
  priority_list: any;
  presales_target_type_list: any;
  presalesFiles: any = [];
  file: File = null;
  authToken = localStorage.getItem("token");
  sourceLeadDisable = false;
  btnStatus = false;
  teamLeaderList:any;
  // selectedUser:any;
  team_lead:any;
  presales_pitch_file:any;
  allJobData: any;
  btnValue: string;
  header: string;
  presales_calling_reason_type_list:any;

  constructor(
    private dialogRef: MatDialogRef<CreatePresalesJobComponent>,
    private fb: FormBuilder,
    private clipBoardMessageService: messageService,
    private _serverService: ServerService,
    @Inject(MAT_DIALOG_DATA) public data,
    
  ) {}

  ngOnInit() {
    this.allJobData = this.data;
    // console.log(this.allJobData)
    this.getCommonDetails()
    if(this.allJobData.previous_value != undefined){
     this.editPresalesJobForm();
     this.btnValue = "SAVE";
     this.header = "Edit Presales Job"
    }
    else{
     this.setCreativeJobForm();
     this.btnValue = "Create Presales Job";
     this.header = "Create Presales Job"
    }
    // this.setCreativeJobForm();
    
    this.getTeamLeader();
  }
  setCreativeJobForm() {
    // this.getCommonDetails();
    this.createPresalesJob = this.fb.group({
      calling_reason: ["", Validators.required],
      calling_type: ["", Validators.required],
      priority: ["", Validators.required],
      target_leads: ["", Validators.required],
      target_type: ["", Validators.required],
      source_leads: ["", Validators.required],
      // team_leader:["",Validators.required],
      // pre_sales_pitch_file: [""],
    });
  }
   editPresalesJobForm() {
   
    // console.log()
    // this.getCommonDetails();
    this.createPresalesJob = this.fb.group({
      calling_reason: [this.allJobData.previous_value.calling_reason, Validators.required],
      calling_type: [this.allJobData.previous_value.calling_type, Validators.required],
      priority: [this.allJobData.previous_value.priority, Validators.required],
      target_leads: [this.allJobData.previous_value.target_leads, Validators.required],
      target_type: [this.allJobData.previous_value.target_type, Validators.required],
      source_leads: [this.allJobData.previous_value.sourced_leads, Validators.required],
      // team_leader:["",Validators.required],
      // pre_sales_pitch_file: [""],
    });
    this.team_lead = this.allJobData.previous_value.tl_id;
    if(this.allJobData.previous_value.pitch != null){
      this.file = this.allJobData.previous_value.pitch[0];
    }
  
    
  this.callingReason('edit')
    // this.file.= this.allJobData.previous_value.pitch[0].name
  }
  
  callingReason(event:any){
    
    if(event === 'edit'){
      if(this.presales_calling_reason_type_list){
    
         this.presales_calling_type_list = this.presales_calling_reason_type_list[this.allJobData.previous_value.calling_reason]
      }
    }
    else{
    this.presales_calling_type_list = this.presales_calling_reason_type_list[this.createPresalesJob.value.calling_reason]
    }
    if(this.createPresalesJob.value.calling_type == 'Fresh' && this.createPresalesJob.value.calling_reason == 'New Project'){
      this.sourceLeadDisable = true;
      // this.createPresalesJob.value.source_leads.
      this.createPresalesJob.value.source_leads = "";
      this.createPresalesJob.get('source_leads').setValue(''); 
      this.createPresalesJob.get('source_leads').clearValidators();
      this.createPresalesJob.get('source_leads').disable();
    }
    else{
      this.sourceLeadDisable = false;
      this.createPresalesJob.get('source_leads').setValidators(Validators.required);
      this.createPresalesJob.get('source_leads').enable();
    }
    // console.log(this.sourceLeadDisable);
    this.createPresalesJob.get('source_leads').updateValueAndValidity();
  
    // this.changeDetectorRef.detectChanges();
  }
  close() {
    this.dialogRef.close();
  }
  createPreSalesJob() {
    
    this.btnStatus = true;
    const formData: FormData = new FormData();
    formData.append(
      "calling_reason",
      this.createPresalesJob.value.calling_reason
    );
    formData.append("calling_type", this.createPresalesJob.value.calling_type);
    formData.append("priority", this.createPresalesJob.value.priority);
    formData.append("target_leads", this.createPresalesJob.value.target_leads);
    formData.append("target_type", this.createPresalesJob.value.target_type);
    formData.append("sourced_leads", this.createPresalesJob.value.source_leads);
    formData.append("tl_id", this.team_lead);

    if(this.file){
      const pitchBlob = new Blob([this.file], { type: this.file.type });
      formData.append("pitch", pitchBlob, this.file.name);
    }
  

   
    formData.append("campaign_id", this.data.campaign_id);
    // formData.append("status", "TODO");
    if(this.allJobData.previous_value != undefined){
      this._serverService
      .put("campaign_module/pre_sales_jobs/"+this.allJobData.previous_value.id, formData, this.authToken)
      .subscribe((data) => {
        this.clipBoardMessageService.showMessgeInText(
          "Pre Sales Job Updated Successfully",
          "success-snackbar"
        );
        this.dialogRef.close(data);
      });
    }
    
    else{
    this._serverService
      .post("campaign_module/pre_sales_jobs", formData, this.authToken)
      .subscribe((data) => {
        this.clipBoardMessageService.showMessgeInText(
          "Pre Sales Job Created Successfully",
          "success-snackbar"
        );
        this.dialogRef.close(data);
      });
    }
  }
  fileChanged(event: any) {
    const temp_file = event.target.files[0]
    
    const MAX_FILE_SIZE = 100 * 1024 * 1024; 
    if (temp_file.size > MAX_FILE_SIZE) {
      this.clipBoardMessageService.showMessgeInText("Max file size allowed is 100MB", "error-snackbar")
      return; 
    }
    this.file = event.target.files[0];
    // console.log(this.file)
  
  }
  getCommonDetails() {
    this._serverService.getAllStatus(this.authToken).subscribe((data: any) => {
      this.presales_calling_reason_list = data.presales_calling_reason_list;
      this.presales_calling_reason_type_list = data.presales_calling_reason_type_list
    
      this.presales_calling_type_list = data.presales_calling_type_list;
      this.priority_list = data.priority_list;
      this.presales_target_type_list = data.presales_target_type_list;
     
    });
  }
  remove() {
    this.file = null;
 
  }
  getTeamLeader(){
    this._serverService.getTeamLeader(this.authToken).subscribe((data: any) => {
      //console.log(data)
      this.teamLeaderList = data.data;
      // console.log(this.teamLeaderList)
      // console.log(data)
    });
  }
  userType(item) {
    return item.org_admin && !item.role
      ? 'Vendor Admin'
      : !item.org_admin && !item.role
      ? 'Vendor Standard User'
      : item.role;
  }
}
